import { render, staticRenderFns } from "./Retorno.vue?vue&type=template&id=785bb6ba&scoped=true&"
import script from "./Retorno.vue?vue&type=script&lang=js&"
export * from "./Retorno.vue?vue&type=script&lang=js&"
import style0 from "./Retorno.vue?vue&type=style&index=0&id=785bb6ba&prod&lang=scss&scoped=true&"
import style1 from "./Retorno.vue?vue&type=style&index=1&id=785bb6ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bb6ba",
  null
  
)

export default component.exports